import { defineChannel, type ChannelDefinition } from '../channel-definition';

// Legacy Twilio SMS. Custom SMS (`sms`) replaces it; workspaces with a Twilio
// integration or the `legacy-twilio` flag still send through it.
export const twilioChannel = defineChannel({
  id: 'twilio',
  icon: 'sms',
  name: 'SMS',
  shortName: 'SMS',
  noun: 'SMS',
  events: [
    'attempted',
    'sent',
    'delivered',
    'deferred',
    'failed',
    'bounced',
    'clicked',
    'converted',
    'drafted',
    'undeliverable',
    'suppressed',
    'replied',
  ],
} as const satisfies ChannelDefinition);
